// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-preload/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springPreloadEN: PageEntry = {
  id: "post.federvorspannung",
  locale: "en",
  slug: "spring-preload",
  seo: {
    title: "Glossary: Spring preload explained simply | Dietz GmbH",
    description: "Spring preload refers to the initial elongation or compression of a spring before an external load is applied. Preload partially deforms the spring before it responds to loads. Spr",
  },
  type: "post",
  h1: "Glossary: Spring preload explained simply",
  intro: "Spring preload refers to the initial elongation or compression of a spring before an external load is applied. Preload partially deforms the spring before it responds to loads. Spring preload is often used in applications where an immediate response of the spring is required or when the load needs to be controlled. The precise definition of spring preload is critical to the functionality and performance of spring systems, especially in areas such as vehicle chassis or industrial machinery.",
  blocks: [

  ],
};
